module.exports = __webpack_public_path__ + "img/ring_skip_0_1_null.c2933091.png";